import { createAction } from '@reduxjs/toolkit';
import * as types from './type';
import axiosAdapter from '../../../utils/Adapters';
import { CMSAPI } from '../../../utils/CmsAPI';
import config from '../../../config';
import { getIndexPagesList } from '../indexPageList/action';
import { currentDate } from '../../../utils/Helper';

const reset = createAction(types.ACTION_RESET);
const requestFetch = createAction(types.ACTION_REQUEST);
const receiveSuccess = createAction(types.ACTION_SUCCESS);
const receiveError = createAction(types.ACTION_ERROR);

const massageData = (response) => {
  const responseData = response.data;
  const data = responseData.result.assets[0];
  if (!data) {
    throw new Error('no data');
  }
  return data;
};

const messageError = (error) => {
  const message =
    ((((error || {}).response || {}).data || {}).error || {}).message || error.message;
  return message;
};

const fetchData = (pageName) => {
  const url = CMSAPI(
    config.lscsPath,
    pageName,
    config.pageType.indexPage,
    config.cmsProjectName,
    true,
    currentDate().getTime(),
  );

  return axiosAdapter({
    url,
  });
};

const resetIndexPages = () => {
  return (dispatch) => {
    dispatch(reset());
  };
};

const queryStart = (curPage, numberOfItemsPerPage) => {
  return (parseInt(curPage, 10) - 1) * numberOfItemsPerPage;
};

const getIndexPages = (pageName, curPage = 1) => {
  return (dispatch) => {
    dispatch(requestFetch({ pageName, curPage }));
    return fetchData(pageName)
      .then((response) => massageData(response))
      .then((data) => {
        dispatch(receiveSuccess(data));
        const content = ((data || {}).content || {}).content || {};
        const numberOfItemsPerPage = content.number_of_items_per_page || config.itemsPerPage;
        const lsQuery = content.indexPage_query || '';
        const sortBy = content.sortBy || '';

        const start = queryStart(curPage, numberOfItemsPerPage);

        if (lsQuery !== '') {
          dispatch(getIndexPagesList(lsQuery, start, numberOfItemsPerPage, sortBy));
        }
      })
      .catch((error) => {
        const message = messageError(error);
        dispatch(receiveError(message));
      });
  };
};

export { getIndexPages, resetIndexPages };
